module.exports = __webpack_public_path__ + "img/primary_11x3_z16.d9bfa71c.svg";